module.exports = __webpack_public_path__ + "static/media/siddharth-vidhana-soudha-trip-02.5668a361.png";